const cache = new Map<string, { value: any; expiresAt: number }>()

const TTL = 5 * 60 * 1000

export function getCached<T>(key: string): T | null {
    const entry = cache.get(key)

    if (!entry) return null

    if (Date.now() > entry.expiresAt) {
        cache.delete(key)
        return null
    }

    return entry.value
}

export function setCached(key: string, value: any) {
    cache.set(key, {
        value,
        expiresAt: Date.now() + TTL,
    })
}
